import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appAutoUpperCase]',
    standalone: false
})
export class AutoUpperCaseDirective {

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    input.value = input.value.toUpperCase();

    // Preserve cursor position
    input.setSelectionRange(start, end);
  }

}
